module.exports = __webpack_public_path__ + "img/21e.ecd94b16.png";